<template>
  <div>
    <apexchart 
      type="donut"
      :options="chartOptions"
      :series="series"
      width="400"
      height="315px !important" 
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import VueApexCharts from 'vue3-apexcharts'

export default defineComponent({
  components: {
    apexchart: VueApexCharts,
  },
  props:{
    series:Object|Array,
    labels:Object|Array,
    colors:Object|Array,
  },
  data() {
    return {
      // Define your data series here
      chartOptions: {
        chart: {
          type: 'donut',
        },
        colors: this.colors,
        labels: this.labels,
        plotOptions: {
          pie: {
            donut: {
              size: '75%',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '16px',
                  color: undefined,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: '24px',
                  color: 'black',
                  offsetY: 7,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Total',
                  color: '#373d3f',
                  fontSize: '16px',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  },
                },
              },
            },
          },
        },
        legend: {
          position: 'bottom',
          offsetX: 0,
          offsetY: 0,
          labels: {
            colors: '#000',
          },
          markers: {
            width: 10,
            height: 10,
          },
        },
        // To create a semi-donut, you can use these options to clip the chart
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: true,
        },
        plotOptions: {
          pie: {
            customScale: 0.9,
            donut: {
              size: '70%',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '16px',
                  color: undefined,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: '24px',
                  color: 'black',
                  offsetY: 7,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Total',
                  color: '#373d3f',
                  fontSize: '16px',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0)
                  },
                },
              },
            },
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: 'bottom',
            },
          },
        }],
      },
    }
  },
  mounted(){
    console.log(this.labels)
    
  },
})
</script>

<style scoped>
/* Add any custom styles here */
</style>
